import React from 'react'
import { Grid, IconButton, Paper, Typography } from '@material-ui/core'
import { Refresh } from '@material-ui/icons'
import { useStyles } from '../styles'

function ErrorCard({ message, action }) {

  const classes = useStyles()

  return (
    <div className='ErrorCard'>
      <Paper className={classes.normalCard}>
        <Grid container spacing={2} style={{ padding: 8 }}>
          <Grid container item xs={12} justifyContent='center'>
            <Typography variant='body2'>
              {message}
            </Typography>
          </Grid>
          <Grid container item xs={12} justifyContent='center'>
            <IconButton onClick={action} variant='contained' color='secondary'>
              <Refresh />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

export default ErrorCard
